import type { CadCategory, IntakeSubType } from '@shared/types';
import { ChipSelect } from '@/components/intake/fields/ChipSelect';
import { useTranslation } from 'react-i18next';

const BY_CATEGORY: Record<CadCategory, IntakeSubType[]> = {
  furniture: [
    'table',
    'chair',
    'shelf',
    'bed',
    'desk',
    'cabinet',
  ],
  mechanical: [
    'bracket',
    'housing',
    'gear',
    'shaft',
    'fastener_part',
    'fixture',
  ],
  architecture: [
    'building',
    'interior_room',
    'site',
    'facade_detail',
  ],
  printing: [
    'decorative',
    'functional',
    'replacement',
    'miniature',
    'enclosure',
  ],
};

export function SubTypeSection({
  category,
  value,
  onChange,
}: {
  category: CadCategory;
  value: IntakeSubType | undefined;
  onChange: (next: IntakeSubType) => void;
}) {
  const { t } = useTranslation('intake');
  const opts = BY_CATEGORY[category].map((subType) => ({
    value: subType,
    label: t(`subTypes.${subType}`),
  }));
  return <ChipSelect options={opts} value={value} onChange={onChange} />;
}
